import { render } from "./OfficeManagement.vue?vue&type=template&id=16cf96e6"
import script from "./OfficeManagement.vue?vue&type=script&lang=js"
export * from "./OfficeManagement.vue?vue&type=script&lang=js"

import "./OfficeManagement.vue?vue&type=style&index=0&id=16cf96e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__